module.exports = () => {
  return {
    data: null,
    error: false,
    added: false,
    quantity: 1,
    mods: [],
    groupMods: [],
    choices: [],
    instructions: null,
    recipient: null,
    filterOptions: {},
    isEdit: false,
    selected: false,
    getChoicesFromCart: false, // deprecated
  }
}
